import axios from "axios";
import { firebaseAuth } from "../firebase/firebaseClient";

const functionsBaseURL = (process.env.REACT_APP_FUNCTIONS_BASE_URL || "").replace(/\/$/, "");
const baseURL = functionsBaseURL;

const backendAPI = axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json"
  }
});

backendAPI.interceptors.request.use(async (config) => {
  if (!baseURL) {
    throw new Error("Missing REACT_APP_FUNCTIONS_BASE_URL in frontend/.env.");
  }

  const url = typeof config.url === "string" ? config.url : "";
  const targetBase = functionsBaseURL;
  const usingFunctionsBase = true;
  config.baseURL = targetBase;

  const isPublicRegister =
    url.includes("/api/user/register/") ||
    url.includes("/user/register/");

  if (!isPublicRegister) {
    // Firebase ID token (or stored session token) for Cloud Functions.
    let token =
      String(localStorage.getItem("authToken") || "").trim() ||
      String(localStorage.getItem("mockAuthToken") || "").trim();

    if (!token) {
      try {
        const raw = localStorage.getItem("userInfo");
        if (raw) {
          const parsed = JSON.parse(raw);
          token = String(parsed?.access || parsed?.authToken || "").trim();
        }
      } catch {
        // ignore
      }
    }

    // Cloud Functions mode fallback: Firebase token can be used there.
    if (!token && usingFunctionsBase) {
      const user = firebaseAuth.currentUser;
      if (user) {
        token = await user.getIdToken();
      } else {
        try {
          const raw = localStorage.getItem("userInfo");
          if (raw) {
            const parsed = JSON.parse(raw);
            token = String(parsed?.idToken || "").trim();
          }
        } catch {
          // ignore
        }
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } else if (config.headers?.Authorization) {
    delete config.headers.Authorization;
  }

  // Only strip `/api` prefix for Cloud Functions base that already embeds API root.
  if (usingFunctionsBase && typeof config.url === "string" && config.url.startsWith("/api/")) {
    config.url = config.url.slice(4);
  }

  return config;
});

export default backendAPI;
